import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValidationMessageService} from '../../../shared/services/validation-message-handle';
import {ToastrService} from 'ngx-toastr';
import {QuestionModel} from '../../models/question.model';
import {AnswerChecboxModel, AnswerModel, AnswersTypeModel} from '../../models/answer.model';

@Component({
  selector: 'admin-question-row',
  templateUrl: './question-row.component.html',
  styleUrls: ['./question-row.component.scss']
})

export class QuestionRowComponent implements OnInit {

  public loading = false;
  public questionForm: FormGroup;
  public answer: AnswerModel = null;
  public answersTypeList: Array<AnswersTypeModel> = [];
  public selectedAnswerTypeId: string = null;
  public selectedAnswerType: AnswersTypeModel = null;

  @Input() question: QuestionModel;
  @Output() deleteQuestionEvent = new EventEmitter();
  @Output() updateQuestionEvent = new EventEmitter();


  constructor(
      private _formBuilder: FormBuilder,
      private validationMessageService: ValidationMessageService,
      private toastr: ToastrService
  ) {

  }

  ngOnInit(): void {

    this.getAnswersTypeList();

    this.questionForm = this._formBuilder.group({
      questionName: ['', Validators.required],
      answerType: ['', Validators.required],
      value: '',
      A: '',
      B: '',
      C: '',
      D: '',
    });

    console.log(this.question.answer.values);

    this.questionForm.patchValue({
      questionName: this.question.questionName,
      answerType: this.question.answerType,
      value: this.question.answer.value,
      A: this.findQuestionValue('A'),
      B: this.findQuestionValue('B'),
      C: this.findQuestionValue('C'),
      D: this.findQuestionValue('D'),
    });

    this.selectedAnswerType = this.question.answerType;
    this.selectedAnswerTypeId = this.question.answerType.id;

  }
  
  findQuestionValue(answare: string): string
  {
     const element = this.question.answer.values.find(x => x.name === answare);
     if (element){
       return element.text;
     }else{
       return '';
     }
  }
  
  getAnswersTypeList(): void {
    this.answersTypeList.push(new AnswersTypeModel().map({id: 1, name: 'Raspuns scris de utilizator', options: null}));
    this.answersTypeList.push(new AnswersTypeModel().map({id: 2, name: 'Doua variante predefinite', options: ['A','B']}));
    this.answersTypeList.push(new AnswersTypeModel().map({id: 3, name: 'Trei variante predefinite', options: ['A','B','C']}));
    this.answersTypeList.push(new AnswersTypeModel().map({id: 4, name: 'Patru variante predefinite', options: ['A','B','C','D']}));
  }

  onAnswerTypeChange(): void {

    this.questionForm.patchValue({
      value: '',
      A: '',
      B: '',
      C: '',
      D: '',
    });

    this.selectedAnswerType = this.answersTypeList.find(i => i.id.toString() === this.selectedAnswerTypeId.toString());

    this.questionForm.patchValue({
      answerType: this.selectedAnswerTypeId,
    });

    this.onFormChanges();

  }

  setAnswersValues(): void
  {
    this.question.answer = new AnswerModel();

    this.question.answer.values = [];
    this.question.answer.type = this.selectedAnswerType;
    this.question.answer.text = this.questionForm.get('questionName').value;

    this.selectedAnswerType.options.forEach((value, index) => {
      const inputValue = this.questionForm.get(value).value;
      this.question.answer.values.push(new AnswerChecboxModel().map({name: value, text: inputValue }));
    });

    this.updateQuestionEvent.emit(this.question);

  }

  deleteQuestion(question: QuestionModel): void
  {
    this.deleteQuestionEvent.emit(question);
  }


  onFormChanges(): void
  {
    this.questionForm.valueChanges.subscribe(x => {
      this.setAnswersValues();
    });
  }
}

